module.exports = __webpack_public_path__ + "media/images/icons/x-0e62e230c83a1e4fe82fe16a1057a04a.svg";